export default {
  namespaced: true,
  state() {
    return {
      passengers: [],
      loading: false,
      error: null,
    }
  },
  mutations: {
    SET_PASSENGERS( state, payload ) {
      state.passengers = payload
    },
    CLEAR_PASSENGERS( state ) {
      state.passengers = []
    },
    SET_LOADING( state, status ) {
      state.loading = status
    },
    SET_ERROR( state, error ) {
      state.error = error
    },
  },
  actions: {
    async savePassengers( { commit }, passengers ) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        commit('SET_PASSENGERS', passengers )
        return true

      } catch( error ) {
        commit( 'SET_ERROR', error )
        throw error

      } finally {
        commit( 'SET_LOADING', false )
      }
    }
  }
}